import { render, staticRenderFns } from "./OmieSendEmailLogHistory.vue?vue&type=template&id=dccca102&scoped=true"
import script from "./OmieSendEmailLogHistory.vue?vue&type=script&lang=js"
export * from "./OmieSendEmailLogHistory.vue?vue&type=script&lang=js"
import style0 from "./OmieSendEmailLogHistory.vue?vue&type=style&index=0&id=dccca102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccca102",
  null
  
)

export default component.exports